module.exports = __webpack_public_path__ + "static/img/logo_061.d813bda6.png";